// extracted by mini-css-extract-plugin
module.exports = {"container":"JobItemContentLabel_container__1Ogg8","sending":"JobItemContentLabel_sending__XkZzm"};